<template>
  <div v-if="errorMessage && !isLoading" class="flex items-center justify-center min-h-screen">
    <div class="text-center">
      <p class="text-red-500 mb-2">{{ $t('property.loadError') }}</p>
      <p class="text-gray-500 text-sm">{{ errorMessage }}</p>
    </div>
  </div>
  <div v-else-if="isEmptyProperty" class="container mx-auto px-4 py-8">
    <div class="max-w-4xl mx-auto">
      <div class="rounded-lg bg-gray-50 p-8 text-center text-gray-600">
        {{ $t('generic.emptyPage') }}
      </div>
    </div>
  </div>
  <div v-else-if="propertyData && propertyData.property">
    <PropertyHero
      :property-name="propertyData.property.name"
      :address="propertyData.property.address"
      :hero-image="propertyData.property.heroImage"
      :specifications="propertyData.property.specifications"
    />
    <PropertyOverview
      :description="propertyData.property.description"
      :features="propertyData.property.features"
      :specifications="propertyData.property.specifications"
    />
    <PropertyGallery :gallery="propertyData.property.gallery" />
    <FloorPlanViewer
      v-if="publicFloorPlan && shouldShowPublicFloorPlan(publicFloorPlan)"
      :floor-plan="publicFloorPlan"
    />
  </div>
  <div v-else class="flex items-center justify-center min-h-screen">
    <p class="text-gray-500">{{ $t('common.loading') }}</p>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import PropertyHero from '../components/property/PropertyHero.vue';
import PropertyOverview from '../components/property/PropertyOverview.vue';
import PropertyGallery from '../components/property/PropertyGallery.vue';
import FloorPlanViewer from '../components/floor-plan/FloorPlanViewer.vue';
import { useLocalePropertyContent } from '../composables/useLocalePropertyContent';
import { pickPublicFloorPlan, shouldShowPublicFloorPlan } from '../utils/propertyFloorPlan.js';

const { content, isLoading, isEmptyProperty, errorMessage } = useLocalePropertyContent();

const propertyData = computed(() => content.value);

const publicFloorPlan = computed(() => {
  const data = propertyData.value;
  if (!data) return null;
  return pickPublicFloorPlan(data.floors, data.property?.publicPlanSiteFloorId);
});
</script>
